import React from 'react';
import _ from 'lodash';

import MerchantPortalAction from '../../../actions/MerchantPortalAction';
import MerchantPortalStore from '../../../stores/MerchantPortalStore';
import CustomerFilter from './CustomerFilter';
import CustomerList from './CustomerList';
import CustomerForm from './CustomerForm';

export default class Customer extends React.Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this._onChange = this._onChange.bind(this);
    this.state = {
      customers: {},
      currentCustomer: undefined,
      settings: {},
      count: '',
      isLoading: false,
    };
    MerchantPortalStore.addChangeListener(this._onChange);
    let customers = MerchantPortalStore.getCustomers();
    if (!customers) {
      this.state.isLoading = true;
      MerchantPortalAction.fetchCustomers();
    } else {
      let settings = MerchantPortalStore.getCustomerSettings();
      this.state.settings = settings;
      this.state.customers = customers.customers;
      this.state.count = customers.count;
      this.state.hasPreviousPage = customers.hasPreviousPage;
      this.state.hasNextPage = customers.hasNextPage;
    }
  }
  componentDidMount() {
    this._isMounted = true;
    window.translate();
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.errors !== this.state.errors) window.translate();
    if (prevState.isLoading !== this.state.isLoading) window.translate();
  }
  componentWillUnmount() {
    this._isMounted = false;
    MerchantPortalStore.removeChangeListener(this._onChange);
  }
  _onChange() {
    let customers = MerchantPortalStore.getCustomers();
    if (this._isMounted && customers) {
      let state = this.state;
      let settings = MerchantPortalStore.getCustomerSettings();
      state.settings = settings;
      state.customers = customers.customers;
      state.count = customers.count;
      state.hasPreviousPage = customers.hasPreviousPage;
      state.hasNextPage = customers.hasNextPage;
      state.isLoading = false;
      this.setState(state);
    }
  }
  changeSelector(event) {
    let settings = this.state.settings;
    settings.perpage = event.target.value;
    settings.page = 1;
    this.setState({ isLoading: true });
    MerchantPortalAction.fetchCustomers(settings);
  }
  setCustomerForm(customer = {}, id) {
    this.setState({ currentCustomer: customer })
    this.refs.customerForm.activateForm(customer, id);
  }
  uploadCustomerCSV(e) {
    MerchantPortalAction.uploadCustomerCSV(e).then(function (result) {
      if (result) {
        this.props.importCustomer(result.customers);
      }
    }.bind(this));
  }
  setLoading() {
    this.setState({ isLoading: true });
  }
  _changePage(modifier) {
    let settings = this.state.settings;
    let page = settings.page;
    page = (1 * page) + modifier;
    if (page < 0) return false;
    settings.page = page;
    this.setState({ isLoading: true });
    MerchantPortalAction.fetchCustomers(settings);
  }

  exportCustomerCSV(e) {
    e.preventDefault();
    let settings = { ...{}, ...this.state.settings };
    delete settings.perpage;
    delete settings.page;

    let query = '';
    query = Object.keys(settings).map(function (k) {
      if (settings[k]) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(settings[k]);
      } else {
        return undefined;
      }
    }).filter(item => !!item).join('&')
    this.setState({ isLoading: true });
    MerchantPortalAction.downloadCustomerCSV(query).then(function (result) {
      if (result) {
        this.setState({ isLoading: false });
      }
    }.bind(this));
  }

  render() {
    return (
      <div className=' div-customer'>
        <div className='page-title' data-translation='merchant.users.title'>Users</div>
        <CustomerForm
          ref='customerForm'
        />
        <CustomerFilter
          settings={this.state.settings}
          setLoading={this.setLoading.bind(this)}
          isLoading={this.state.isLoading}
        />
        <CustomerList
          setLoading={this.setLoading.bind(this)}
          uploadCustomerCSV={this.uploadCustomerCSV.bind(this)}
          exportCustomerCSV={this.exportCustomerCSV.bind(this)}
          setCustomerForm={this.setCustomerForm.bind(this)}
          count={this.state.count}
          customers={this.state.customers}
          changeSelector={this.changeSelector.bind(this)}
          perpage={this.state.settings.perpage}
          isLoading={this.state.isLoading}
          hasPreviousPage={this.state.hasPreviousPage}
          hasNextPage={this.state.hasNextPage}
          toPreviousPage={this._changePage.bind(this, -1)}
          toNextPage={this._changePage.bind(this, 1)}
        />
      </div>
    );
  }
}